import { render, staticRenderFns } from "./studyTopicDetails.vue?vue&type=template&id=c19f1b90&scoped=true"
import script from "./studyTopicDetails.vue?vue&type=script&lang=js"
export * from "./studyTopicDetails.vue?vue&type=script&lang=js"
import style0 from "./studyTopicDetails.vue?vue&type=style&index=0&id=c19f1b90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19f1b90",
  null
  
)

export default component.exports